import {
  getContent,
  getUserDetails,
  signinService,
  signupService,
  submitData,
  validateOTP,
} from '../../ApiServices/AuthServices';
import { toast } from 'react-toastify';
import { appExtraFunctions } from './AppActions';

export const signupAction = (values, history) => dispatch => {
  dispatch(appExtraFunctions('btnLoaderOne', true));
  signupService(values)
    .then(response => {
      dispatch(appExtraFunctions('btnLoaderOne', false));
      toast.success('OTP sent successfully.');
      dispatch({ type: 'STORE_REGISTRATION_FORM', payload: values });
      history('/verify/account');
    })
    .catch(error => {
      dispatch(appExtraFunctions('btnLoaderOne', false));
      toast.error(error.response.data.message ?? error.error, { autoClose: 5000 });
    });
};

export const validateUserOTP = (values, history) => dispatch => {
  dispatch(appExtraFunctions('btnLoaderOne', true));
  validateOTP(values)
    .then(response => {
      dispatch(appExtraFunctions('btnLoaderOne', false));
      toast.success('Successfully registered.');
      dispatch({ type: 'STORE_REGISTRATION_FORM', payload: {} });
      dispatch({ type: 'USER_INFO', payload: response?.data?.payload });
      history('/');
    })
    .catch(error => {
      dispatch(appExtraFunctions('btnLoaderOne', false));
      toast.error(error?.response?.data?.message ?? error?.error, { autoClose: 5000 });
    });
};

export const userLogout = navigate => dispatch => {
  dispatch(appExtraFunctions('adminView', 'customer'));
  dispatch({ type: 'LOGOUT_ACTION', payload: '' });
  toast.success('Successfully logged out.');
  navigate('/');
};

export const signinAction = (values, history) => dispatch => {
  dispatch(appExtraFunctions('btnLoaderOne', true));
  signinService(values)
    .then(response => {
      dispatch({ type: 'USER_INFO', payload: response?.data?.payload });
      toast.success('Successfully logged in.');
      dispatch(appExtraFunctions('adminView', 'customer'));
      dispatch(appExtraFunctions('btnLoaderOne', false));
      history('/');
    })
    .catch(error => {
      dispatch(appExtraFunctions('btnLoaderOne', false));
      toast.error(error?.response?.data?.message ?? error?.error, { autoClose: 5000 });
    });
};

export const myAccountDetailsAction = token => dispatch => {
  getUserDetails(token)
    .then(response => {
      dispatch({ type: 'USER_INFO_FETCHED', payload: response?.data?.payload });
    })
    .catch(error => {
      toast.error(error?.response?.data?.message ?? error.error, { autoClose: 5000 });
    });
};

export const submitForm = (type, token, values, id, navigate) => dispatch => {
  dispatch(appExtraFunctions('btnLoaderOne', true));

  submitData(type, token, values, id)
    .then(res => {
      dispatch(appExtraFunctions('btnLoaderOne', false));
      switch (type) {
        case 'addBillingAddress':
          toast.success('Successfully Created.');
          dispatch({ type: 'USER_ADDRESSES', payload: res.data.payload });
          return;

        case 'editBillingAddress':
          toast.success('Successfully Updated.');
          dispatch({ type: 'USER_ADDRESSES', payload: res.data.payload });
          return;

        case 'contactForm':
          toast.success(
            'We’ve received your information and will get back to you as soon as possible.',
            { autoClose: 5000 }
          );
          return;

        case 'resendOpt':
          toast.success('An OTP has been sent to your WhatsApp number.', { autoClose: 5000 });
          return;

        case 'placeUserOrder':
        case 'verifyOrderPayment':
          if (res?.data?.success) {
            toast.success('Successfully order placed.');
            dispatch({ type: 'PLACED_ORDER_INFO', payload: res?.data?.payload });
            navigate('/order/success');

            setTimeout(() => {
              dispatch({ type: 'CLEAR_CART', payload: [] });
            }, 100);
          }
          return;

        default:
          break;
      }
    })
    .catch(error => {
      dispatch(appExtraFunctions('btnLoaderOne', false));

      if (type === 'verifyOrderPayment') {
        navigate('/order/failed');
      }

      toast.error(error?.response?.data?.message ?? error?.error, { autoClose: 5000 });
    });
};

export const getPageContent = (type, token, id, options) => dispatch => {
  getContent(type, token, id, options).then(res => {
    switch (type) {
      case 'userBillingAddresses':
        return dispatch({ type: 'USER_ADDRESSES', payload: res.data.payload });
      case 'getUserOrders':
        return dispatch({ type: 'GET_USER_ORDERS', payload: res.data.payload });

      default:
        break;
    }
  });
};
